import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { useLang } from "../../contexts/LanguageContext";
import { useAuth } from "../../contexts/AuthContext";
import { FileText, FilePlus, ImageIcon, Mail, MailCheck } from "lucide-react";

export default function AdminDashboard() {
  const { t } = useLang();
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  const cards = stats
    ? [
        { l: t.admin.total_articles, v: stats.total_articles, icon: FileText },
        { l: t.admin.published, v: stats.published, icon: FileText },
        { l: t.admin.drafts, v: stats.drafts, icon: FilePlus },
        { l: t.admin.media_files, v: stats.media, icon: ImageIcon },
        { l: t.admin.messages, v: stats.contact, icon: Mail },
        { l: t.admin.subscribers, v: stats.newsletter, icon: MailCheck },
      ]
    : [];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-end justify-between mb-10 gap-6 flex-wrap">
        <div>
          <div className="label-eyebrow text-ink mb-2">{t.admin.welcome}</div>
          <h1 className="heading-serif text-4xl text-ink">{user?.name}</h1>
        </div>
        <Link
          to="/admin/articles/new"
          data-testid="admin-new-article-btn"
          className="bg-ink text-white h-11 px-5 text-[12px] uppercase tracking-[0.2em] font-medium hover:bg-ink/90 inline-flex items-center"
        >
          {t.admin.new_article}
        </Link>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
        {cards.map((c, i) => {
          const Icon = c.icon;
          return (
            <div key={i} className="border border-slate200 bg-white p-6">
              <div className="flex items-center justify-between mb-4">
                <div className="label-eyebrow text-slate500">{c.l}</div>
                <Icon className="w-4 h-4 text-slate500" />
              </div>
              <div className="heading-serif text-4xl text-ink">{c.v}</div>
            </div>
          );
        })}
      </div>

      {stats && (
        <div className="border border-slate200 bg-white p-6">
          <div className="label-eyebrow text-ink mb-4">By Category</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 text-[13px]">
            {Object.entries(stats.by_category).map(([k, v]) => (
              <div key={k} className="flex items-center justify-between border-b border-slate200 pb-2">
                <span className="text-slate600">{t.categories[k] || k}</span>
                <span className="font-semibold text-ink">{v}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
